// extracted by mini-css-extract-plugin
export default {"back":"ProductDescriptionContent_back__uJKji","title":"ProductDescriptionContent_title__sPTye"};